import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './template.scss';
import { HtmlEditor, Toolbar, Item, } from 'devextreme-react/html-editor';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import { TextArea } from 'devextreme-react/text-area';
import {createTemplate, updateTemplate, getTemplateById, } from '../../api/api'
import { useAuth } from '../../contexts/auth';
import List, { ItemDragging } from 'devextreme-react/list';
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { Form, Label, SimpleItem, RequiredRule } from 'devextreme-react/form';
import devices from 'devextreme/core/devices';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
const isPhone = devices.current().deviceType === 'phone'

const sizeValues = [ "8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt" ];
const fontValues = [ "Arial", "Georgia", "Tahoma", "Times New Roman", "Verdana" ];
const headerValues = [ false, 1, 2, 3, 4, 5 ];

export default function Template() {
  const { user, refreshSession } = useAuth();
  let { template_id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [template, setTemplate] = useState(null);
  const [htmlData, setHtmlData] = useState("");
  const [templateName, setTemplateName] = useState("New Template");
  const [questions, setQuestions] = useState([]);
  const [instructions, setInstructions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [currentInstruction, setCurrentInstruction] = useState(null);
  const [suggestedQuestions, setSuggestedQuestions] = useState([]);

  const onValueChanged = useCallback((e) => {
    setHtmlData(e.value)
  }, [])

  const onNameChanged = useCallback((e) => {
    setTemplateName(e.value);
  }, [setTemplateName])

  const onTemplateDataSuccess = useCallback((data) => {
    setTemplate(data)
    setHtmlData(data.html);
    if (data.questions) {
      setQuestions(data.questions);
    }
    if (data.instructions) {
      setInstructions(data.instructions);
    }
    if (data.template_name) {
      setTemplateName(data.template_name)
    }
    setLoading(false);
  }, [])

  const onTemplateDataSaveSuccess = useCallback((data) => {
    onTemplateDataSuccess(data)
    navigate("/templates")
  }, [onTemplateDataSuccess, navigate])

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      setLoading(false);
      console.log(error);
    }
  }, [refreshSession]);

  const saveTemplate = useCallback(() => {
    setLoading(true);
    var data = {}
    data['html'] = htmlData
    data['questions'] = questions
    data['instructions'] = instructions
    data['template_name'] = templateName
    if (template) {
      data['template_id'] = template.template_id
      data['owner_id'] = template.owner_id
      updateTemplate(user, data, onTemplateDataSaveSuccess, onError);
    } else {
      createTemplate(user, data, onTemplateDataSaveSuccess, onError);
    }

  }, [user, htmlData, questions, instructions, templateName, template, onTemplateDataSaveSuccess, onError])

  const addQuestion = useCallback(() => {
    setCurrentQuestion({new: true});
  }, [setCurrentQuestion])

  const onQuestionClick = useCallback((item) => {
    setCurrentQuestion({new: false, index:item.itemIndex, question:item.itemData});
  }, [setCurrentQuestion])

  const addInstruction = useCallback(() => {
    setCurrentInstruction({new: true});
  }, [setCurrentInstruction])

  const onInstructionClick = useCallback((item) => {
    setCurrentInstruction({new: false, index:item.itemIndex, instruction:item.itemData});
  }, [setCurrentInstruction])

  useEffect(() => {
    if (user.signInUserSession) {
      if (template_id) {
        getTemplateById(user, template_id, onTemplateDataSuccess, onError)
      } else {
        setLoading(false)
      }
    }
  }, [user, template_id, onTemplateDataSuccess, onError]);

  const onDragQuestionsStart = useCallback(
    (e) => {
      e.itemData = e.fromData === 'actualList'
        ? questions[e.fromIndex]
        : suggestedQuestions[e.fromIndex];
    },
    [questions, suggestedQuestions],
  );

  const onDragInstructionsStart = useCallback(
    (e) => {
      e.itemData = e.fromData === 'instructionsList'
        ? instructions[e.fromIndex]
        : null;
    },
    [instructions],
  );

  /*const onAdd = useCallback(
    (e) => {
      const q = e.toData === 'actualList' ? questions : suggestedQuestions;
      const updatedQ = [...q];
      updatedQ.splice(e.toIndex, 0, e.itemData);
      if (e.toData === 'actualList') {
        setQuestions(updatedQ);
      } else {
        setSuggestedQuestions(updatedQ);
      }
    },
    [setQuestions, setSuggestedQuestions, questions, suggestedQuestions],
  );
  const onRemove = useCallback(
    (e) => {
      const q = e.toData === 'actualList' ? questions : suggestedQuestions;
      const updatedQ = [...q];
      updatedQ.splice(e.fromIndex, 1);
      if (e.toData === 'actualList') {
        setQuestions(updatedQ);
      } else {
        setSuggestedQuestions(updatedQ);
      }
    },
    [setQuestions, setSuggestedQuestions, questions, suggestedQuestions],
  );*/
  const onReorderQuestions = useCallback(
    (e) => {
      if (e.fromData === e.toData) {
        const updateQuestion = (q) => {
          const updatedQ = [...q];
          const [movedQ] = updatedQ.splice(e.fromIndex, 1);
          updatedQ.splice(e.toIndex, 0, movedQ);
          return updatedQ;
        };
        if (e.fromData === 'actualList') {
          setQuestions((prevTasks) => updateQuestion(prevTasks));
        } else {
          setSuggestedQuestions((prevTasks) => updateQuestion(prevTasks));
        }
      } else {
        //onRemove(e);
        //onAdd(e);
      }
    },
    //[onAdd, onRemove],
    [],
  );

  const onReorderInstructions = useCallback(
    (e) => {
      if (e.fromData === e.toData) {
        const updateInstruction = (i) => {
          const updatedI = [...i];
          const [movedI] = updatedI.splice(e.fromIndex, 1);
          updatedI.splice(e.toIndex, 0, movedI);
          return updatedI;
        };
        setInstructions((prevTasks) => updateInstruction(prevTasks));
      }
    },
    [],
  );

  const popupAttributes = useMemo(() => {
      return {
          id: 'elementId',
          class: 'add-question-popup'
      }
  }, []);

  const onCancelQuestion = () => {
    setCurrentQuestion(null);
  }

  const onSaveQuestion = async () => {
    setSaveButtonOptions({
      disabled: true,
      text: 'Save',
      type: 'default',
      width: '100%',
      onClick: onSaveQuestion,
    });
    if (currentQuestion.new) {
      questions.push(currentQuestion.question)
      setQuestions([...questions])
    } else {
      questions[currentQuestion.index] = currentQuestion.question
      setQuestions([...questions])
    }
    setCurrentQuestion(null);
  }

  const onCancelInstruction = () => {
    setCurrentInstruction(null);
  }

  const onSaveInstruction = async () => {
    setSaveInstructionButtonOptions({
      disabled: true,
      text: 'Save',
      type: 'default',
      width: '100%',
      onClick: onSaveInstruction,
    });
    if (currentInstruction.new) {
      instructions.push(currentInstruction.instruction)
      setInstructions([...instructions])
    } else {
      instructions[currentInstruction.index] = currentInstruction.instruction
      setInstructions([...instructions])
    }
    setCurrentInstruction(null);
  }

  const onFormDataChanged = (e) => {
    setSaveButtonOptions({
      disabled: (currentQuestion.question.length===0),
      text: 'Save',
      type: 'default',
      width: '100%',
      onClick: onSaveQuestion,
    });
  }

  const onFormInstructionDataChanged = (e) => {
    setSaveInstructionButtonOptions({
      disabled: (currentInstruction.instruction.length===0),
      text: 'Save',
      type: 'default',
      width: '100%',
      onClick: onSaveInstruction,
    });
  }

  const cancelButtonOptions = {
    disabled: false,
    text: 'Cancel',
    width: '100%',
    onClick: onCancelQuestion,
  };

  const [saveButtonOptions, setSaveButtonOptions] = useState({
    disabled: false,
    text: 'Save',
    type: 'default',
    width: '100%',
    onClick: onSaveQuestion,
  });

  const cancelInstructionButtonOptions = {
    disabled: false,
    text: 'Cancel',
    width: '100%',
    onClick: onCancelInstruction,
  };

  const [saveInstructionButtonOptions, setSaveInstructionButtonOptions] = useState({
    disabled: false,
    text: 'Save',
    type: 'default',
    width: '100%',
    onClick: onSaveInstruction,
  });

  return (
    <React.Fragment >
      {loading?
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
          <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
          />
      </div>
      :
      <div>
        <div className="d-flex flex-row justify-content-between align-items-end mb-3">
          <div className="pe-3" style={{minWidth:"60%"}}>
          <TextBox
            value={templateName}
            label="Template Name"
            labelMode="floating"
            onValueChanged={onNameChanged}
            width="100%"
          />
          </div>
          <div className="d-flex flex-row">
            <Button
                text="Cancel"
                icon="fas fa-chevron-left"
                onClick={() => {navigate("/templates")}}
            />
            <div className="mx-3"/>
            <Button
                text="Save Template"
                type="success"
                icon="fas fa-save"
                onClick={saveTemplate}
            />
          </div>
        </div>
        <hr/>
        <div className="d-flex flex-row h-100" style={{maxHeight:"74vh"}}>
          <div className="pe-3" style={{minWidth:"60%"}}>
            <HtmlEditor
              onValueChanged={onValueChanged}
              value={htmlData}
              height="100%"
            >
              <Toolbar multiline={true}>
                <Item name="undo" />
                <Item name="redo" />
                <Item name="separator" />
                <Item name="size" acceptedValues={sizeValues} />
                <Item name="font" acceptedValues={fontValues} />
                <Item name="separator" />
                <Item name="bold" />
                <Item name="italic" />
                <Item name="strike" />
                <Item name="underline" />
                <Item name="separator" />
                <Item name="alignLeft" />
                <Item name="alignCenter" />
                <Item name="alignRight" />
                <Item name="alignJustify" />
                <Item name="separator" />
                <Item name="orderedList" />
                <Item name="bulletList" />
                <Item name="separator" />
                <Item name="header" acceptedValues={headerValues} />
                <Item name="separator" />
                <Item name="color" />
                <Item name="background" />
                <Item name="separator" />
                <Item name="link" />
                <Item name="image" />
                <Item name="separator" />
                <Item name="clear" />
                <Item name="codeBlock" />
                <Item name="blockquote" />
                <Item name="separator" />
                <Item name="separator" />
                <Item name="insertTable" />
                <Item name="insertHeaderRow" />
                <Item name="insertRowAbove" />
                <Item name="insertRowBelow" />
                <Item name="separator" />
                <Item name="insertColumnLeft" />
                <Item name="insertColumnRight" />
                <Item name="separator" />
                <Item name="deleteColumn" />
                <Item name="deleteRow" />
                <Item name="deleteTable" />
                <Item name="separator" />
                <Item name="cellProperties" />
                <Item name="tableProperties" />

              </Toolbar>
            </HtmlEditor>
          </div>
          <div className="" style={{minWidth:"40%"}}>
            <div className="d-flex flex-column justify-content-between h-100">
              <div className="d-flex flex-column" style={{minHeight:"49%"}}>
                <div className="d-flex flex-row justify-content-between align-items-center mb-2">
                  <h5 className="my-0">Template Questions</h5>
                  <Button
                      text="Add"
                      icon="fas fa-plus"
                      onClick={addQuestion}
                  />
                </div>
                <div className="dx-card h-100" >
                  <List
                    dataSource={questions}
                    allowItemDeleting={true}
                    itemDeleteMode={"static"}
                    onItemClick={onQuestionClick}
                  >
                    <ItemDragging
                      allowReordering={true}
                      group="tasks"
                      data="actualList"
                      onDragStart={onDragQuestionsStart}
                      onReorder={onReorderQuestions}
                    ></ItemDragging>
                  </List>
                </div>
              </div>
              <hr/>
              <div className="d-flex flex-column" style={{minHeight:"49%"}}>
                <div className="d-flex flex-row justify-content-between align-items-center mb-2">
                  <h5 className="my-0">Custom Instructions</h5>
                  <Button
                      text="Add"
                      icon="fas fa-plus"
                      onClick={addInstruction}
                  />
                </div>
                <div className="dx-card h-100">
                  <List
                    dataSource={instructions}
                    allowItemDeleting={true}
                    itemDeleteMode={"static"}
                    onItemClick={onInstructionClick}
                  >
                    <ItemDragging
                      allowReordering={true}
                      group="tasks"
                      data="instructionsList"
                      onDragStart={onDragInstructionsStart}
                      onReorder={onReorderInstructions}
                    ></ItemDragging>
                  </List>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
      <Popup
        wrapperAttr={popupAttributes}
        visible={currentQuestion !== null}
        onHidden={() => setCurrentQuestion(null)}
        dragEnabled={false}
        showCloseButton={false}
        showTitle={true}
        fullScreen={isPhone}
        title={currentQuestion?.new?"Add Question":"Edit Question"}
        width={380}
        height={380}
      >
          <Position at="center" my="center" collision="fit" />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            options={saveButtonOptions}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={cancelButtonOptions}
          />

          <Form
            id={'form'}
            formData={currentQuestion}
            labelLocation={'top'}
            onFieldDataChanged={onFormDataChanged}
          >
              <SimpleItem
                editorType="dxTextArea"
                dataField="question"
                editorOptions={{
                  height: "200px",
                }}
              >
                <Label text="Question"/>
                <RequiredRule message="Question is required" />
              </SimpleItem>
          </Form>

      </Popup>

      <Popup
        wrapperAttr={popupAttributes}
        visible={currentInstruction !== null}
        onHidden={() => setCurrentInstruction(null)}
        dragEnabled={false}
        showCloseButton={false}
        showTitle={true}
        fullScreen={isPhone}
        title={currentInstruction?.new?"Add Instruction":"Edit Instruction"}
        width={380}
        height={380}
      >
          <Position at="center" my="center"collision="fit" />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            options={saveInstructionButtonOptions}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={cancelInstructionButtonOptions}
          />

          <Form
            id={'form2'}
            formData={currentInstruction}
            labelLocation={'top'}
            onFieldDataChanged={onFormInstructionDataChanged}
          >
              <SimpleItem
                editorType="dxTextArea"
                dataField="instruction"
                editorOptions={{
                  height: "200px",
                }}
              >
                <Label text="Instruction"/>
                <RequiredRule message="Instruction is required" />
              </SimpleItem>
          </Form>

      </Popup>
    </React.Fragment>
)}
